module.exports = __webpack_public_path__ + "static/media/img_patient_null.abd856e1.svg";